import { Ref, ref, watch } from 'vue'

const storageKey = 'operatorFontSizeScale'
const validScales = [1.0, 1.25, 1.5, 1.75] as const
type Scale = (typeof validScales)[number]

function readInitial(): Scale {
  const saved = Number(window.localStorage.getItem(storageKey))
  return (validScales as readonly number[]).includes(saved) ? (saved as Scale) : 1.0
}

const scale = ref<Scale>(readInitial())
watch(scale, (v) => window.localStorage.setItem(storageKey, String(v)))

export default function useOperatorFontSize(): {
  scale: Ref<Scale>
  validScales: readonly Scale[]
} {
  return { scale, validScales }
}
